import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { queryClient } from "./AppQuries/client-query.jsx";
// import { RouterProvider } from 'react-router-dom';
import { ConfigProvider } from "antd";

import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import { base_path } from "./environment.jsx";
import "../src/style/css/feather.css";
import "../src/style/css/line-awesome.min.css";
import "../src/style/scss/main.scss";
import "../src/style/icons/fontawesome/css/fontawesome.min.css";
import "../src/style/icons/fontawesome/css/all.min.css";
import "../src/style/css/style.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./core/redux/store.jsx";
import AllRoutes from "./Router/router.jsx";
import SessionExpiryHandler from "../src/core/Operations/SessionExpiryHandler.jsx";
import { App as AntdApp } from "antd";
import { ToastProvider } from "Components/UI/ToastProvider.jsx";

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = createRoot(rootElement);
  // root.render(
  //   <React.StrictMode>
  //   <QueryClientProvider client={queryClient}>
  //     <Provider store={store}>
  //       {/* <BrowserRouter basename={base_path}> */}
  //         <PersistGate loading={null} persistor={persistor}>
  //           {/* Ensure session handling logic is triggered before routes */}
  //           <SessionExpiryHandler />
  //           <AllRoutes />
  //         </PersistGate>
  //       {/* </BrowserRouter> */}
  //     </Provider>
  //   </QueryClientProvider>
  // </React.StrictMode>
  // );
  root.render(
    <React.StrictMode>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <ConfigProvider
                theme={{
                  token: {
                    fontFamily: ' "Montserrat", sans-serif',
                    // fontFamily: ' "inter", sans-serif',
                  },
                }}
              >
                <AllRoutes />
              </ConfigProvider>
            </PersistGate>
          </Provider>
        </QueryClientProvider>
      </ToastProvider>
    </React.StrictMode>
  );
} else {
  console.error("Element with id 'root' not found.");
}
